import { createFileRoute } from '@tanstack/react-router';

import Chart3D from '@/components/Chart3D';
import { ConfigureChartButton } from '@/components/ConfigureChartButton';
import { DownloadButton } from '@/components/DownloadButton';
import { RangeFilterButton } from '@/components/RangeFilterButton';
import { useChartTitle } from '@/contexts/ChartContext';
import { eightMaxOpeningData } from '@/data/eightMaxOpeningData';
import { useChartDefaults } from '@/hooks/useChartDefaults';
import { usePageActions } from '@/hooks/usePageActions';
import { buildChartHeadMeta } from '@/lib/headMeta';

export const Route = createFileRoute('/eightmax-opening')({
  component: EightMaxOpeningRoute,
  head: () => buildChartHeadMeta({ chartData: eightMaxOpeningData, ogImagePath: '/og/eightmax-opening.png' }),
});

function EightMaxOpeningRoute() {
  useChartTitle(eightMaxOpeningData);

  // Use categorical color scheme and show legend for this chart
  useChartDefaults({
    colorScheme: 'CATEGORICAL_8',
    showLegend: true,
    maxHeight: 2.5,
    useLogScale: false,
  });

  usePageActions({
    secondary: () => (
      <>
        <RangeFilterButton />
        <DownloadButton />
      </>
    ),
    primary: () => <ConfigureChartButton />,
  });

  return <Chart3D data={eightMaxOpeningData} />;
}
